// @ts-nocheck -- Build nélküli, kézzel írt plain JS sziget; a repo checkJs típusellenőrzését szándékosan kihagyjuk (lásd CLAUDE.md).
/*
 * Build nélküli, plain böngésző-JS. A repo oxlint konfigja a TS+build világra
 * van hangolva (stdlib/common wrapperek, no-semicolon, arrow-tiltás), ami itt
 * nem alkalmazható és valódi hibát nem fog (a correctness kategória eleve off).
 * Ezért erre a szigetre kikapcsoljuk. Ha később build kerül fölé, a fájlt
 * TS-re érdemes konvertálni és ezt a sort törölni. Lásd README.
 */
/* oxlint-disable */

/**
 * TudásFM – cookie hozzájárulás (orestbida CookieConsent v3 + Google Consent Mode v2).
 *
 * A könyvtárat NEM ez a modul tölti be: a CDN <link>/<script> az index.html <head>-jében
 * van (a pug/cookieConsent.pug mixinek HTML-megfelelője), így a window.CookieConsent már
 * kész, mire ez a fájl fut. A hozzájárulás alapértelmezése ("minden denied") is ott áll be,
 * a GTM ELŐTT – ez a modul csak a felhasználó tényleges döntését vezeti át a gtag felé.
 *
 * Minta: projects/immaster/frontend/scripts/cookieConsent.ts és
 * projects/csillagsuli/entries/host/runCookieConsent.ts.
 *
 * @see https://cookieconsent.orestbida.com/reference/configuration-reference.html
 */

const SERVICE_AD_STORAGE = 'ad_storage';
const SERVICE_AD_USER_DATA = 'ad_user_data';
const SERVICE_AD_PERSONALIZATION = 'ad_personalization';
const SERVICE_ANALYTICS_STORAGE = 'analytics_storage';
const SERVICE_FUNCTIONALITY_STORAGE = 'functionality_storage';
const SERVICE_PERSONALIZATION_STORAGE = 'personalization_storage';
const SERVICE_SECURITY_STORAGE = 'security_storage';

const CAT_NECESSARY = 'necessary';
const CAT_ANALYTICS = 'analytics';
const CAT_ADVERTISEMENT = 'advertisement';
const CAT_FUNCTIONALITY = 'functionality';
const CAT_SECURITY = 'security';

// A „Több információ" szekció kapcsolati címe.
const CONTACT_EMAIL = 'info@tudas.fm';

/**
 * A felhasználó választásának átvezetése a Google Consent Mode felé.
 *
 * Az alapértelmezést az index.html <head>-je adja (minden denied); ez a függvény csak
 * a különbséget küldi el. Az onFirstConsent / onConsent / onChange mindegyikéből hívjuk,
 * ezért TILOS ide bármilyen egyszeri művelet (pl. event listener felfűzés) – lásd
 * initCookieButton().
 */
function updateGtagConsent() {
  const consent = window.CookieConsent;

  if (typeof window.gtag !== 'function') {
    return;
  }

  /**
   * Egy Consent Mode jel értéke a hozzá tartozó kategória/szolgáltatás állapotából.
   * @param {string} service - A Consent Mode jel neve (pl. 'analytics_storage').
   * @param {string} category - A CookieConsent kategória, amelyhez a jel tartozik.
   * @returns {string} 'granted' vagy 'denied'.
   */
  const signal = (service, category) => {
    return consent.acceptedService(service, category) ? 'granted' : 'denied';
  };

  window.gtag('consent', 'update', {
    [SERVICE_ANALYTICS_STORAGE]: signal(SERVICE_ANALYTICS_STORAGE, CAT_ANALYTICS),
    [SERVICE_AD_STORAGE]: signal(SERVICE_AD_STORAGE, CAT_ADVERTISEMENT),
    [SERVICE_AD_USER_DATA]: signal(SERVICE_AD_USER_DATA, CAT_ADVERTISEMENT),
    [SERVICE_AD_PERSONALIZATION]: signal(SERVICE_AD_PERSONALIZATION, CAT_ADVERTISEMENT),
    [SERVICE_PERSONALIZATION_STORAGE]: signal(SERVICE_PERSONALIZATION_STORAGE, CAT_ADVERTISEMENT),
    [SERVICE_FUNCTIONALITY_STORAGE]: signal(SERVICE_FUNCTIONALITY_STORAGE, CAT_FUNCTIONALITY),

    // Az immaster ezt fixen 'granted'-re állítja (ügyfélkérés). A tudásfm-en nincs ilyen
    // megkötés, és a beállítás-ablakban a felhasználó ki tudja kapcsolni a Biztonság
    // kategóriát – ezért itt a tényleges választását vezetjük át, hogy a UI ne hazudjon.
    [SERVICE_SECURITY_STORAGE]: signal(SERVICE_SECURITY_STORAGE, CAT_SECURITY),
  });
}

/**
 * A lebegő cookie-gomb kattintás-kezelője. EGYSZER fut, a modul betöltésekor.
 *
 * (Az immaster-mintában ez az updateGtagConsent()-en belül van, amit az onChange minden
 * preferencia-mentéskor meghív – ott ezért minden mentés után egy újabb click listener
 * ragad a gombra, és a modal N-szer nyílik. Itt szét van szedve.)
 */
function initCookieButton() {
  const button = document.querySelector('.cookie-button');

  if (button === null) {
    return;
  }

  button.addEventListener('click', () => {
    window.CookieConsent.showPreferences();
  });
}

/**
 * A gombot csak akkor mutatjuk, ha a felhasználó már döntött – addig a banner van kint.
 * Idempotens, mert a consent-callbackekből többször is meghívódik.
 */
function showCookieButton() {
  const button = document.querySelector('.cookie-button');

  if (button === null) {
    return;
  }

  button.classList.add('visible');
}

/** A consent megszületése / módosulása utáni közös teendők. */
function handleConsent() {
  updateGtagConsent();
  showCookieButton();
}

/**
 * A consent banner és a beállítás-ablak felépítése és elindítása.
 */
function initCookieConsent() {
  const consent = window.CookieConsent;

  if (consent === undefined) {
    return;
  }

  consent.run({
    // A választás minden változásakor újraküldjük a Consent Mode jeleket.
    onFirstConsent: handleConsent,
    onConsent: handleConsent,
    onChange: handleConsent,

    guiOptions: {
      consentModal: {
        layout: 'cloud inline',
        position: 'center center',
      },
    },

    categories: {
      [CAT_NECESSARY]: { enabled: true, readOnly: true },

      [CAT_FUNCTIONALITY]: {
        services: {
          [SERVICE_FUNCTIONALITY_STORAGE]: {
            label: 'Az oldal funkcióit támogató tárolást engedélyezi, például a beállításaid megőrzését.',
          },
        },
      },

      [CAT_ANALYTICS]: {
        enabled: false,

        autoClear: {
          cookies: [
            // A regex a GA4 _ga_<mérési azonosító> alakú sütijét is fedi.
            { name: /^_ga/ },
            { name: '_gid' },
          ],
        },

        services: {
          [SERVICE_ANALYTICS_STORAGE]: {
            label: 'Lehetővé teszi az analitikával kapcsolatos tárolást, például a látogatás időtartamának mérését.',
          },
        },
      },

      [CAT_ADVERTISEMENT]: {
        autoClear: {
          cookies: [
            { name: /^_gcl/ },
          ],
        },

        services: {
          [SERVICE_AD_STORAGE]: {
            label: 'Engedélyezi a reklámozással kapcsolatos tárolást (például cookie-kat).',
          },
          [SERVICE_AD_USER_DATA]: {
            label: 'Hozzájárulást ad a hirdetésekkel kapcsolatos felhasználói adatok Google-nak történő elküldéséhez.',
          },
          [SERVICE_AD_PERSONALIZATION]: {
            label: 'Személyre szabott hirdetésekhez való hozzájárulás beállítása.',
          },
          [SERVICE_PERSONALIZATION_STORAGE]: {
            label: 'Lehetővé teszi a személyre szabással kapcsolatos tárolást, például a videóajánlásokat.',
          },
        },
      },

      [CAT_SECURITY]: {
        enabled: true,

        services: {
          [SERVICE_SECURITY_STORAGE]: {
            label: [
              'Lehetővé teszi a biztonsággal kapcsolatos tárolást,',
              'például a csalás megelőzését és egyéb felhasználói védelmet.',
            ].join(' '),
          },
        },
      },
    },

    language: {
      default: 'hu',
      translations: {
        hu: {
          consentModal: {
            title: 'Az oldal sütiket használ',
            description: [
              'A TudásFM oldala cookie-kat (sütiket) használ, hogy mérni tudjuk, mennyire',
              'hasznos, amit készítünk. Az így gyűjtött adatokat anonim módon kezeljük.',
              'Te döntöd el, mit engedélyezel – a választásodat később bármikor módosíthatod.',
            ].join(' '),
            acceptAllBtn: 'Összes elfogadása',
            acceptNecessaryBtn: 'Összes elutasítása',
            showPreferencesBtn: 'Egyéni beállítások',
          },
          preferencesModal: {
            title: 'Egyéni beállítások',
            acceptAllBtn: 'Összes elfogadása',
            acceptNecessaryBtn: 'Összes elutasítása',
            savePreferencesBtn: 'Jelenlegi beállítások mentése',
            closeIconLabel: 'Ablak bezárása',
            sections: [
              {
                title: 'Általánosan a sütikről',
                description: [
                  'A sütik kis adatcsomagok, amiket a böngésződ tárol. Egy részük nélkül az',
                  'oldal nem működne, más részük ahhoz kell, hogy lássuk, mely műsorokat',
                  'keresik a legtöbben.<br><br>Az általunk gyűjtött adatokat anonim módon',
                  'kezeljük, és nem használjuk a személyed azonosítására.<br><br>Az alábbi',
                  'kategóriákat külön-külön engedélyezheted vagy tilthatod. A beállításokat',
                  'a bal alsó cookie-ikonra kattintva bármikor újra elő tudod hozni.',
                ].join(' '),
              },
              {
                title: 'Feltétlenül szükséges sütik',
                description: [
                  'Az oldal alapvető működéséhez kellenek – ilyen többek között a',
                  'cookie-beállításaidat megőrző süti is. Ezek nem tárolnak',
                  'személyazonosításra alkalmas adatot, és nem kapcsolhatók ki.',
                ].join(' '),
                linkedCategory: CAT_NECESSARY,
              },
              {
                title: 'Funkcionális',
                description: [
                  'A funkcionális sütik bizonyos kényelmi funkciókat tesznek lehetővé,',
                  'például a beállításaid megőrzését vagy a beágyazott tartalmak',
                  'kezelését. Nélkülük az oldal működik, de kevésbé kényelmesen.',
                ].join(' '),
                linkedCategory: CAT_FUNCTIONALITY,
              },
              {
                title: 'Teljesítmény és analitika',
                description: [
                  'Ezek a sütik arról gyűjtenek információt, hogyan használod az oldalt:',
                  'melyik műsorokat nyitod meg, mit keresel. Ebből tudjuk, mit érdemes',
                  'fejleszteni. Az adatok anonimizáltak, és nem azonosítanak téged.',
                ].join(' '),
                linkedCategory: CAT_ANALYTICS,
                cookieTable: {
                  headers: {
                    name: 'Süti',
                    domain: 'Szolgáltatás',
                    description: 'Leírás',
                    expiration: 'Lejárat',
                  },
                  body: [
                    {
                      name: '_ga',
                      domain: 'Google Analytics',
                      description: 'Anonim látogató-azonosító. <a href="https://business.safety.google/adscookies/" rel="noopener" target="_blank">Részletek</a>',
                      expiration: '2 év',
                    },
                    {
                      name: '_ga_G-9V12SCLGYE',
                      domain: 'Google Analytics',
                      description: 'A GA4 mérés munkamenet-állapota. <a href="https://business.safety.google/adscookies/" rel="noopener" target="_blank">Részletek</a>',
                      expiration: '2 év',
                    },
                    {
                      name: '_gid',
                      domain: 'Google Analytics',
                      description: 'Anonim látogató-azonosító. <a href="https://business.safety.google/adscookies/" rel="noopener" target="_blank">Részletek</a>',
                      expiration: '24 óra',
                    },
                  ],
                },
              },
              {
                title: 'Hirdetés',
                description: [
                  'A Google cookie-kat használhat a hirdetések megjelenítéséhez és',
                  'személyre szabásához, a megjelenítések számának korlátozásához,',
                  'valamint a hirdetések hatékonyságának mérésére. A saját hirdetési',
                  'beállításaidat a',
                  '<a href="https://g.co/adsettings" rel="noopener" target="_blank">g.co/adsettings</a>',
                  'oldalon módosíthatod.',
                ].join(' '),
                linkedCategory: CAT_ADVERTISEMENT,
              },
              {
                title: 'Biztonság',
                description: [
                  'A hozzájárulási beállítások védelmét és a visszaélések megelőzését',
                  'szolgálja. Ide tartozik az illetéktelen hozzáférés elleni védelem,',
                  'valamint a GDPR és más adatvédelmi előírások betartása.',
                ].join(' '),
                linkedCategory: CAT_SECURITY,
              },
              {
                title: 'Több információ',
                description: [
                  'Ha kérdésed van a sütikkel vagy az adataid kezelésével kapcsolatban,',
                  `írj nekünk a <a href="mailto:${CONTACT_EMAIL}">${CONTACT_EMAIL}</a> címre.`,
                ].join(' '),
              },
            ],
          },
        },
      },
    },
  });
}

// A gomb listenere ELŐBB kerül fel, hogy a consent.run() callbackjei már felfűzött
// kezelőjű gombot tegyenek láthatóvá.
initCookieButton();
initCookieConsent();
